import { Button as RebassButton } from "rebass"
import { themeGet } from "styled-system"
import styled from "styled-components"

const Button = styled(RebassButton).attrs({
  bg: `#222020`,
  fontSize: [2, 3, 4],
  borderRadius: 0
})`
  cursor: pointer;
  &:focus {
    box-shadow: inset 0 0 0 2px;
  }
  &:hover {
    color: ${themeGet(`colors.darkgray`)};
    background-color: ${themeGet(`colors.white`)};
    box-shadow: inset 0 0 0 2px ${themeGet(`colors.darkgray`)};
  }
`

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js